import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { ticketColors, ticketFonts } from '../../shared/theme/ticketColors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: ticketColors.bg,
    padding: 0,
  },
  list: {
    flex: 1,
  },
  stack: {
    gap: 10,
  },
  headerStack: {
    gap: 10,
  },
  listSheet: {
    overflow: 'hidden',
  },
  listContent: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: spacing.md,
  },
  listContentEmptyGrow: {
    flexGrow: 1,
  },
  /** Empty Square: título/meta afuera + nest CTA adentro (proto). */
  emptyProto: {
    paddingVertical: 16,
    paddingHorizontal: 14,
    gap: 4,
  },
  emptyProtoTitle: {
    fontSize: 18,
    fontWeight: '800',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  emptyProtoMeta: {
    fontSize: 13,
    color: ticketColors.ink2,
    lineHeight: 18,
    fontFamily: ticketFonts.sans,
    marginBottom: 8,
  },
  /** CTA Historial — mobile full-width (h48 ghost tile). */
  mobileHistoryBtn: {
    height: 48,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
    alignItems: 'center',
    justifyContent: 'center',
  },
  mobileHistoryBtnText: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },
});
